var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeatballsH = function SvgMeatballsH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M8 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM24 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })));
};
export default SvgMeatballsH;